import React, { useCallback, useEffect, useState } from "react";
import CircularLoader from "./CircularLoader";
import EmptyListPlaceholder from "./EmptyListPlaceholder";
import CustomerCallLogsForModule from "../Customers/CustomerCallLogsForModule";
import CallServices from "../../services/CallServices";

const callServices = new CallServices();

interface InputProps {
    referenceId: number;
    referenceModelName: string;
}

const ServiceCallLogsTab = ({ referenceId, referenceModelName }: InputProps) => {
    const [subData, setSubData] = useState<any>(null);
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [pageSize, setPageSize] = useState(10);

    const refreshData = useCallback(
        (pageNo: number) => {
            setIsLoading(true);
            callServices
                .getCallLogsForRef(
                    pageSize,
                    pageSize * pageNo,
                    { order: "DESC", field: "createdAt" },
                    referenceModelName,
                    referenceId
                )
                .then((data) => {
                    setSubData(data);
                    setIsLoading(false);
                })
                .catch(() => {
                    setIsLoading(false);
                });
        },
        [referenceId, referenceModelName, pageSize]
    );

    useEffect(() => {
        refreshData(0);
    }, [refreshData]);

    return (
        <div>
            {isLoading && <CircularLoader />}
            {subData &&
                subData?.data &&
                subData?.data?.data &&
                Array.isArray(subData?.data?.data) &&
                (subData?.data?.data?.length > 0 ? (
                    <CustomerCallLogsForModule
                        isLoading={isLoading}
                        count={subData?.data?.count}
                        data={subData?.data?.data}
                        refreshData={refreshData}
                        setPageSize={setPageSize}
                        pageSize={pageSize}
                    />
                ) : (
                    <EmptyListPlaceholder message="No Call Logs Found" />
                ))}
        </div>
    );
};

export default ServiceCallLogsTab;
